import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

import ErrorBox from '../common/ErrorBox';
import ModalFocusManager from '../../util/ModalFocusManager';
const Strings = require('../../../../app/shared/Strings');

const propTypes = {
    show: PropTypes.bool,
    hasError: PropTypes.bool,
    modalTitle: PropTypes.string,
    buttonText: PropTypes.string,
    closeHandler: PropTypes.func.isRequired,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    message: PropTypes.string,
    confirmHandler: PropTypes.func.isRequired,
    cancelHandler: PropTypes.func,
    cancelButtonText: PropTypes.string,
    confirmData: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.number]),
    confirmButtonBsStyle: PropTypes.string,
    enforceFocus: PropTypes.bool,
    restoreFocus: PropTypes.bool,
    backdrop: PropTypes.oneOf([true, false, 'static']),
    modalTitleId: PropTypes.string,
    closeLabel: PropTypes.string,
    confirmButtonAriaLabel: PropTypes.string,
    trapFocus: PropTypes.bool,
};

const defaultProps = {
    show: true,
    hasError: false,
    modalTitle: Strings['en'].common.CONFIRM_DECISION,
    buttonText: Strings['en'].common.CONFIRM_LC,
    confirmButtonAriaLabel: Strings['en'].common.CONFIRM_LC,
    text: '',
    message: '',
    cancelHandler: () => { return; },
    cancelButtonText: '',
    confirmData: null,
    confirmButtonBsStyle: 'primary',
    cancelButtonBsStyle: 'primary',
    enforceFocus: false,
    restoreFocus: false,
    backdrop: false,
    modalTitleId: "mzl-modal-title",
    closeLabel: Strings['en'].common.CLOSE,
    trapFocus: false,
};

const _MODAL_ID = "confirm-modal";
function ConfirmModal(props) {
    React.useEffect(() => {
        $("#"+_MODAL_ID+" > div > div.modal-header > button.close").focus();
        if (props.trapFocus) {
            const focusUtil = new ModalFocusManager(document.getElementById(_MODAL_ID));
            focusUtil.addModalFocusTrapHandler();
            return () => {
                focusUtil.removeModalFocusTrapHandler();
            };
        }
    }, []);

    return (
        <Modal
            id={_MODAL_ID}
            show={props.show}
            keyboard
            autoFocus={propTypes.trapFocus ? false : true}
            enforceFocus={propTypes.trapFocus ? false : props.enforceFocus}
            restoreFocus={props.restoreFocus}
            backdrop={props.backdrop}
            animation={false}
            //container={mountNode}
            onHide={props.closeHandler}
            aria-labelledby={props.modalTitleId}
            aria-modal="true"
        >
            <Modal.Header
                closeButton
                closeLabel={props.closeLabel}
                onHide={props.closeHandler}
            >
                <Modal.Title as="h2" className="h4" id={props.modalTitleId}>{props.modalTitle}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {props.hasError ? <ErrorBox error={{ message: props.message }} /> : null}
                {(props.extraBodyClass) ? 
                    <span className={props.extraBodyClass}>{props.text}</span>
                    :
                    props.text
                }
            </Modal.Body>

            <Modal.Footer>
                <Button
                    aria-label={props.confirmButtonAriaLabel}
                    variant={props.confirmButtonBsStyle}
                    onClick={props.confirmHandler.bind(null, props.confirmData)}
                >
                    {props.buttonText}
                </Button>
                {(!!props.cancelButtonText) &&
                    <Button
                        variant={props.cancelButtonBsStyle}
                        onClick={props.cancelHandler.bind(null, props.cancelData)}
                    >
                        {props.cancelButtonText}
                    </Button>
                }
            </Modal.Footer>
        </Modal>
    );
}

ConfirmModal.propTypes = propTypes;
ConfirmModal.defaultProps = defaultProps;

export default ConfirmModal;